import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import { isUnifiedStaffCaseIntakeRole } from '@brands/Utils/reviewProfileBasePath';
import React from 'react';

import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';
import CaseCreationSelectDateAndTime from '../../CaseCreation/SelectDateAndTime/SelectDateAndTime';
import CaseCreationSelectDateAndTimeAdmin from '../../CaseCreation/SelectDateAndTime/SelectDateAndTimeAdmin';
import SelectDateAndTime from './SelectDateAndTime';

const SelectDentaInsuranceValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
      component = <SelectDateAndTime />;
      break;
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
      component = <CaseCreationSelectDateAndTimeAdmin />;
      break;
    case UserRoleName.Collector:
    case UserRoleName.CareAdvisor: {
      const roleName = user.userInfo.role.name;
      component = isUnifiedStaffCaseIntakeRole(roleName) ? (
        <CaseCreationSelectDateAndTime />
      ) : (
        <SelectDateAndTime />
      );
      break;
    }
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default SelectDentaInsuranceValidation;
